module.exports = __webpack_public_path__ + "static/img/legend_xg_dark_vertical.cb37c91.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/legend_xg_dark_vertical.png
// module id = Uen6
// module chunks = 94